export default {
  title: 'Relatórios de rendimentos',
  sections: {
    new_report: 'Novo relatório',
  },
  form: {
    period: {
      label: 'Período',
    },
  },
  buttons: {
    export: 'Exportar',
  },
  toasts: {
    failed_to_create_report: 'Falha ao criar relatório',
  },
};
